import React from 'react';
import PropTypes from 'prop-types';
import heroBg from '../../assets/images/heroBG.png';
import detailsPNG from '../../assets/images/details.png';
import CourseBatchDetails from '../course-batch-details/CourseBatchDetails';

function DetailsHeader({
  skuName, orderDetails, createdAt, transferMeta, orderItems,
}) {
  let CreatedAt = createdAt;

  if (!createdAt) {
    CreatedAt = Date.now();
  }

  const formatedDate = new Date(Number(CreatedAt)).toLocaleString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  return (
    <div className="flex relative flex-col items-center">
      <div
        style={{ backgroundImage: `url(${heroBg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        className=" relative flex justify-center w-full p-8 pb-12 "
      >
        <div className="flex flex-col items-center text-white">
          <div className=" p-4 rounded-full">
            <img className="w-[96px]" alt="" src={detailsPNG} />
          </div>
          <div className="flex flex-col mt-4 gap-1 item-center text-center">
            <h1 className="text-xl font-bold">{skuName}</h1>
            {transferMeta?.productName && transferMeta?.transferTo?.productName && (
            <p className="text-sm flex items-center flex-wrap justify-center gap-2">
              <span className="opacity-90">{transferMeta.productName}</span>
              <span>&rarr;</span>
              <span className="font-semibold">{transferMeta.transferTo.productName}</span>
            </p>
            )}
            <p className="font-semibold">
              Order ID:
              <span className="font-normal">{orderDetails?.id}</span>
            </p>
            <p className="font-normal">{formatedDate}</p>
            <CourseBatchDetails orderItems={orderItems} variant="light" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailsHeader;
DetailsHeader.propTypes = {
  skuName: PropTypes.string.isRequired,
  orderDetails: PropTypes.object.isRequired,
  createdAt: PropTypes.bigint,
  transferMeta: PropTypes.shape({
    productName: PropTypes.string,
    transferTo: PropTypes.shape({
      productName: PropTypes.string,
    }),
  }),
  orderItems: PropTypes.array,
};
